// @ts-check
import { FileText, Image, Link2, MessageSquare, UserPlus, Video } from "lucide-react";

/**
 * Vocabulário da automação — espelha
 * `server/src/modules/automations/automations.schemas.js`.
 */

export const DELAYS = [
  "Imediato",
  "Após 5 min",
  "Após 15 min",
  "Após 30 min",
  "Após 1h",
  "Após 2h",
  "Após 4h",
  "Após 1 dia",
  "Após 2 dias",
  "Após 3 dias",
  "Após 7 dias",
];

export const STEP_TYPES = {
  text: { label: "Texto", icon: MessageSquare },
  image: { label: "Imagem", icon: Image },
  file: { label: "Arquivo", icon: FileText },
  link: { label: "Link", icon: Link2 },
  video: { label: "Vídeo", icon: Video },
};

export const STEP_TYPE_IDS = Object.keys(STEP_TYPES);

export const TRIGGERS = [
  { id: "whatsapp", label: "WhatsApp", sub: "Nova mensagem recebida", icon: MessageSquare },
  { id: "lead", label: "Novo Lead", sub: "Lead criado no sistema", icon: UserPlus },
];

export const TRIGGER_MATCHES = [
  { id: "any", label: "Qualquer palavra" },
  { id: "all", label: "Todas as palavras" },
  { id: "exact", label: "Frase exata" },
];

export const WEEK_DAYS = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

const DIAS_UTEIS = ["Seg", "Ter", "Qua", "Qui", "Sex"];

/**
 * Resume a janela de envio em texto: "Seg-Sex 09:00-19:00".
 * @param {{ days?: string[], start?: string, end?: string }} schedule
 */
export function formatSchedule(schedule) {
  const dias = schedule?.days ?? [];
  if (dias.length === 0) return "Sem janela definida";

  const todosOsDias = dias.length === 7;
  const somenteUteis = dias.length === 5 && DIAS_UTEIS.every((d) => dias.includes(d));

  const rotulo = todosOsDias ? "Todos os dias" : somenteUteis ? "Seg-Sex" : dias.join(", ");
  return `${rotulo} ${schedule.start}-${schedule.end}`;
}

/** @param {string} tipo */
export const stepTypeMeta = (tipo) => STEP_TYPES[tipo] ?? STEP_TYPES.text;
